(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/pnp-step-indicator/react/prescript.js') >= 0) return;  svs.modules.push('/components/lb-ui/pnp-step-indicator/react/prescript.js');

'use strict';

svs = svs || {};
svs.components = svs.components || {};
svs.components.lb_ui = svs.components.lb_ui || {};
svs.components.lb_ui.pnpStepIndicator = svs.components.lb_ui.pnpStepIndicator || {};
svs.components.lb_ui.pnpStepIndicator.PnpStepIndicator = svs.components.lb_ui.pnpStepIndicator.PnpStepIndicator || {};

 })(window);